import React from 'react';
import { usePopperTooltip } from 'react-popper-tooltip';
import 'react-popper-tooltip/dist/styles.css';
import { Field } from 'formik';
import Select from 'react-select';
import tooltip from '@images/tooltip.png';
import * as S from './styles';

function CustomSelect({
  className,
  name,
  label,
  options,
  searchble,
  optional,
  placeholder,
  mgBottom,
  maxWidth,
  tooltipMsg,
  disabled,
  value,
  onChange,
  ...rest
}) {
  const { getArrowProps, getTooltipProps, setTooltipRef, setTriggerRef, visible } =
    usePopperTooltip();

  const renderValue = (field) => options.find((option) => option.value === field.value);

  return (
    <S.FormControl marginBottom={mgBottom} className={className} maxWidth={maxWidth}>
      {label && (
        <label htmlFor={name} className="labelSelect" disabled={disabled}>
          {label} {optional && <span>opcional</span>}{' '}
          {!!tooltipMsg && <img src={tooltip} ref={setTriggerRef} />}
        </label>
      )}
      {visible && !!tooltipMsg && (
        <div ref={setTooltipRef} {...getTooltipProps({ className: 'tooltip-container' })}>
          {tooltipMsg}
          <div {...getArrowProps({ className: 'tooltip-arrow' })} />
        </div>
      )}

      <Field id={name} name={name}>
        {({ field, form, meta }) => (
          <Select
            name={field.name}
            classNamePrefix="formikSelect"
            className={meta.touched && meta.error && 'overrider-border'}
            id={field.name}
            onBlur={field.onBlur}
            value={value || (options && renderValue(field))}
            onChange={(option) => {
              if (onChange) return onChange(field.name, option.value);
              return form.setFieldValue(field.name, option.value);
            }}
            options={options}
            placeholder={placeholder || 'Selecione'}
            isSearchable={searchble}
            error={meta.touched && meta.error}
            isDisabled={disabled}
            {...rest}
          />
        )}
      </Field>
      <S.Errors name={name} maxWidth={maxWidth}>
        {(msgError) => <span>{msgError}</span>}
      </S.Errors>
    </S.FormControl>
  );
}

export default CustomSelect;
